// Turbolinks turbolinks:load event:
$(document).on('turbolinks:load', do_when_ready_for_image_uploads_new);

function do_when_ready_for_image_uploads_new() {
  // Only for #image_uploads_new
  if ($('#image_uploads_new').length > 0) {
    // Constants (cleaner code):
    const the_form = $('#new_image_upload_bundle');
    const num_files_per_sync = 8;
    //  Form data decided on page load:
    const event_zone_id = the_form.find("input[name='image_upload_bundle[event_zone_id]'][type='hidden']").
                                   val();
    // EventUploadDetails (event_id, chronotrack_identifier, obstacles):
    detail_fields =
      the_form.find("input[type='hidden'][name^='image_upload_bundle[event_upload_details_attributes][']").
               serializeArray();
    var detailsObj = {};
    prefix_length = 'image_upload_bundle[event_upload_details_attributes]['.length
    $.each(detail_fields, function(i, field) {
      name = field.name.substr(prefix_length, field.name.length)
      index = parseInt(name.substr(0,2));
      if (typeof detailsObj[index] == 'undefined') {
        detailsObj[index] = {'obstacles':[]};
      }
      if (name.endsWith('][event_id]')) {
        name = 'event_id'
      }
      else {
        if (name.endsWith('][chronotrack_identifier]'))
          name = 'chronotrack_identifier'
        else
          name = 'obstacles';
      };
      if (name === 'obstacles')
        detailsObj[index]['obstacles'].push(field.value);
      else
        detailsObj[index][name] = field.value;
    });
    const event_upload_details = detailsObj
    // State variables:
    var no_request_sent                 = true;   // No Ajax calls has been made
    var ajax_error_message              = '';     // Catastrophic error just happened
    var no_clean_up_request_pending     = true;   // Catastrophic error, cleanup Ajax sent
    var strange_ajax_response_so_submit = false;  // Catastrophic error, and all cleaned up
    var image_upload_bundle_id          = 0;      // I have an ImageUploadBundle ID
    var s3_direct_uploads_done          = false;  // S3 direct uploads ended
    var num_sync_requests_pending       = 0;      // Number of sync Ajax sent pending
    // Handy functions to support state (see definitions at the end):
    var strange_ajax_response_so_stop = null;  // ajax_error_message is present (not null or an empty string)
    var bundle_exists                 = null;  // image_upload_bundle_id > 0
    var cleanupOnError                = null;  // Sets the error message/and initiates cleanup, if needed   
    var doCleanup                     = null;  // Cleanups pending files after an error that forces stopping
    var checkIfCanSubmit              = null;  // Function checking if it can submit, and does it
    var check_if_can_submit           = null;  // Timer to see if can submit (from 1 sec. after click submit)

    the_form.submit(function(e) {
      const no_files_to_send = ($('#image_upload_bundle_photos')[0].files.length == 0);
      if (no_files_to_send) {
        the_form.unbind('submit').submit();
      }
      else {
        e.preventDefault();
        check_if_can_submit = setTimeout(checkIfCanSubmit, 1000);
      };
    });

    addEventListener('direct-upload:end', event => {
      // A direct upload has ended.
      if ((no_request_sent || bundle_exists()) && !strange_ajax_response_so_stop()) {
        var blobs_to_send = [];
        the_form.find("input:enabled[name='image_upload_bundle[photos][]'][type='hidden']").
                 each(function(id, elem) {
                   blobs_to_send.push($(elem).val());
                 });
        if ((no_request_sent && (blobs_to_send.length > 0)) || (blobs_to_send.length >= num_files_per_sync)) {
          no_request_sent = false;
          num_sync_requests_pending += 1;
          $.ajax('/upload_photos/upload_create_sync',
                 { type: 'POST',
                   dataType: 'json',
                   data: { image_upload_bundle: { id: image_upload_bundle_id,
                                                  photos: blobs_to_send,
                                                  // The rest will ignored if bundle_exists():
                                                  event_zone_id: event_zone_id,
                                                  // Arrays of objects passed over:
                                                  event_upload_details_attributes: event_upload_details }
                         }
                 }
          ).done(function(data) {
              returned_id = Number(data['id']);
              if (isNaN(returned_id) || (returned_id < 0)) returned_id = 0;
              if (returned_id > 0) {
                // We'll enforce the server-side id, even if it had been set:
                image_upload_bundle_id = returned_id;
                $("#image_upload_bundle_id").val(returned_id);
                // Disabling inputs for the attached blobs:
                var attached_blobs = data['blobs_attached'];
                if (Array.isArray(attached_blobs)) {
                  for (var i = 0; i < attached_blobs.length; i++) {
                    the_form.
                      find("input:enabled[name='image_upload_bundle[photos][]'][type='hidden']" +
                           `[value='${attached_blobs[i]}']`).
                      prop('disabled', true);
                  }
                };
                // And mark the file(s) names as done (color):
                var attached_filenames = data['blobs_filenames'];
                if (Array.isArray(attached_filenames)) {
                  for (var i = 0; i < attached_filenames.length; i++) {
                    the_form.find('div.direct-upload--complete').
                             has(`span:contains('${attached_filenames[i]}')`).
                             addClass('direct-upload__sent');
                  }
                };
                if (strange_ajax_response_so_stop() && (num_sync_requests_pending == 1)) {
                  // If an error happened in previous calls pending to return, this is the last:
                  doCleanup();
                }
              }
              else {
                // Important error... stop
                if (strange_ajax_response_so_stop()) {
                  // If it was already stopping and no more callbacks are pending:
                  if (num_sync_requests_pending == 1) {
                    // If an error happened in previous calls pending to return, this is the last:
                    doCleanup();
                  }        
                }
                else {
                  // Something went wrong, and we need to stop the world (and submit with a special state)
                  var message = 'Upload error - process halted!';
                  if ((typeof data['error_message'] == 'string') && (data['error_message'].length > 0)) {
                    message += ' ' + data['error_message']
                  }
                  cleanupOnError(message);
                  if (num_sync_requests_pending == 1) {
                    // Only this one Ajax call failed:
                    doCleanup();
                  }
                  // if num_sync_requests_pending > 1, we'll wait for all calls to finish before cleaning up
                }
              }
          }).fail(function() {
              if (strange_ajax_response_so_stop() && (num_sync_requests_pending == 1)) {
                // If an error happened in previous calls pending to return, this is the last:
                doCleanup();
              }
              else {
                // Nothing catastrophic failed before, or if it did, there are still request sent, 
                // so we'll continue:
                if (!bundle_exists()) {
                  // First call failed, so we'll try again:
                  no_request_sent = true;
                }
                // If the bundle_id was set, the next call (or submit) will take care of the remaining files
              }
          }).always(function() {
              num_sync_requests_pending -= 1;
              // Just in case all is ready to go:
              if ((num_sync_requests_pending == 0) && s3_direct_uploads_done) {
                checkIfCanSubmit();
              }
          });
        }
      }
    });

    addEventListener('direct-uploads:end', event => {
      // All direct uploads have ended. We can submit the form now
      s3_direct_uploads_done = true;
      checkIfCanSubmit();
    });

    // Utility functions:
    
    // We have a bundle, or not (image_upload_bundle_id > 0)
    bundle_exists = function() {
      return (typeof image_upload_bundle_id === 'number') &&
             Number.isInteger(image_upload_bundle_id) && 
             (image_upload_bundle_id > 0);
    };
    // Stop all and wait until all Ajax responses come back (ajax_error_message is present)
    strange_ajax_response_so_stop = function() {
      return (typeof ajax_error_message === 'string') &&
             (ajax_error_message.length > 0);
    };
    // Sets the error message and initiates cleanup, if needed:
    cleanupOnError = function(error_message) {
      // It only makes sense to call this if no error has happened before
      if (!strange_ajax_response_so_stop()) {
        // Sets the error message to submit:
        $('#image_upload_bundle_error_message').val(error_message); 
        // And allows to submit, for Exceptional circumstances:
        ajax_error_message = error_message;
      }
    };
    // Cleanups pending files after an error that forces stopping
    doCleanup = function() {
      // Request to cleanup orphans and disable their inputs:
      var blobs_to_delete = [];
      the_form.find("input:enabled[name='image_upload_bundle[photos][]'][type='hidden']").
               each(function(id, elem) {
                 blobs_to_delete.push($(elem).val());
                 // Disabling the blobs inputs, so nothing else is saved on submit:
                 $(elem).prop('disabled', true);
               });
      // We asume that all will be ok, no retries or further errors:
      if (blobs_to_delete.length > 0) {
        no_clean_up_request_pending = false;
        $.ajax('/upload_photos/upload_clean_sync',
               { type: 'POST',
                 dataType: 'json',
                 data: { image_upload_bundle: { photos: blobs_to_delete }}
               }
        ).always(function() {
          // If any enabled blob input exist (S3 upload completed), call this again,
          // otherwise allow submission:
          var blobs_pending = [];
          the_form.find("input:enabled[name='image_upload_bundle[photos][]'][type='hidden']").
                   each(function(id, elem) {
                     blobs_pending.push($(elem).val());
                   });
          // Blobs pending (2nd try to remove them):
          if (blobs_pending.length > 0) {
            doCleanup();
          }
          else {
            // Allows the submit to happen:
            no_clean_up_request_pending = true;
            strange_ajax_response_so_submit = true;
            // We won't wait until the interval finishes (this could mean more uploads to s3):
            checkIfCanSubmit();
          }
         });
      }
      else {
        // Allows the submit to go happen:
        no_clean_up_request_pending = true;
        strange_ajax_response_so_submit = true;
        // We won't wait until the interval finishes (this could mean more uploads to s3):
        checkIfCanSubmit();
      }
    };
    // Interval function, to check if I should submit:
    checkIfCanSubmit = function () {
      if (strange_ajax_response_so_submit ||
          (s3_direct_uploads_done && no_clean_up_request_pending && (bundle_exists() || no_request_sent))) {
        the_form.unbind('submit').submit()
      }
    };
  }
};
